import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: () => import('@/views/clueIndex'), meta: { keepAlive: true }, hidden: true },
    { path: '/clueDetail/:clueId/:clueStage', name: "clueDetail", component: () => import('@/views/clueDetail'), meta: { keepAlive: false }, hidden: true },
    { path: '/clueAdd', component: () => import('@/views/clueAdd'), hidden: true }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js